import { MainsIcon } from "@thrivetribe/mvf.assets.icons.mains-icon";
import { TimeIcon } from "@thrivetribe/mvf.assets.icons.time-icon";
import { CaloriesIcon } from "@thrivetribe/mvf.assets.icons.calories-icon";
import { TickIcon } from "@thrivetribe/mvf.assets.icons.tick-icon";
import React from "react";
import "./recipe-banner.scss";

const basicPluralizeFunc = (
  singlarWord: string,
  amount?: number,
  showValue?: boolean
) => {
  if (amount) {
    if (amount === 1)
      return showValue ? `${amount} ${singlarWord}` : singlarWord;
    return showValue ? `${amount} ${singlarWord}s` : singlarWord + "s";
  }
  return singlarWord;
};

const formatTime = (time: string | number | undefined) => {
  if (time) {
    if (Number(time) <= 60) {
      return `${time} mins`;
    } else {
      const hours = Math.trunc(Number(time) / 60);
      const mins = Number(time) % 60;

      return `${hours} ${basicPluralizeFunc(
        "hr",
        hours
      )} ${mins} ${basicPluralizeFunc("min", mins)}`;
    }
  }
};

export type RecipeBannerProps = {
  title: string;
  description: string;
  imgUrl: string;
  mealType?: string;
  time?: string | number;
  kCal?: string;
  healthBenefit?: string[];
  servings?: number;
};

export function RecipeBanner({
  title,
  description,
  imgUrl,
  mealType,
  servings,
  healthBenefit,
  time,
  kCal,
}: RecipeBannerProps) {
  const formatedTime = formatTime(time);
  const servingsText = `This recipe makes ${basicPluralizeFunc(
    "serving",
    servings,
    true
  )}`;
  return (
    <div className="recipe-banner">
      <div
        className="recipe-banner__image"
        style={{ backgroundImage: `url(${imgUrl})` }}
      />
      <div className="recipe-banner__content">
        <div className="recipe-banner__content--header">
          <h2>{title}</h2>
          <div className="recipe-banner__content--icons">
            {mealType && (
              <div className="recipe-banner__content--icon">
                <MainsIcon />
                <p>{mealType}</p>
              </div>
            )}
            {time && (
              <div className="recipe-banner__content--icon">
                <TimeIcon />
                <p>{formatedTime}</p>
              </div>
            )}
            {kCal && (
              <div className="recipe-banner__content--icon">
                <CaloriesIcon />
                <p className="recipe-banner__content--last-icon">{kCal} kcal per serving</p>
              </div>
            )}
          </div>
        </div>
        <p className="recipe-banner__content--serving">{servingsText}</p>
        <p className="recipe-banner__content--description">{description}</p>
        <div className="recipe-banner__content--benefits">
          {healthBenefit?.map((benefit, index) => (
            <div className="recipe-banner__content--benefit" key={index}>
              <TickIcon />
              <p>{benefit}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
